import { render, staticRenderFns } from "./SkillsView.vue?vue&type=template&id=08017666&"
import script from "./SkillsView.vue?vue&type=script&lang=js&"
export * from "./SkillsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports